<template>

  <b-row class="mb-4">
    <b-col >
      <b-input v-model="domainname" @keydown.enter.native="result()" @input="duplicate = false" type="text"  :placeholder="$t('domain.searchInput.placeholder')"></b-input>
    </b-col>
    <b-col class="verticalcenter">
      <b-link @click="result()"  :disabled="duplicatename"><h3>Suchen</h3></b-link>
    </b-col>
  </b-row>

</template>

<script>
  import Domain from "@/store/models/domain/domain"
  import DomainSearchResult from "@/store/models/layout/domain_search_result"
  import DomainPrice from "@/store/models/domain/domain_price"
  import FormatPriceMixin from "@/mixins/formatPriceMixin"
  import DomainPriceDiscount from "@/store/models/domain/domain_price_discount"
  import DomainTld from "@/store/models/domain/domain_tld"
  import axios from "@/store/vue-axios"

  export default {
    name: "luma-search-domain",
    mixins:[FormatPriceMixin],
    data:()=>({
      domainname:'',
      searchresult:'',
      duplicate:false,
      price: DomainPrice
    }),
    computed:{
      duplicatename(){
        return this.duplicate
      },
      domainC(){
        if(!DomainSearchResult.all()) return
        return DomainSearchResult.all()
      }
    },

    methods:{
      async result(){
        if (!this.domainname) return
        if(this.checkDomainNameDuplicate()) return
        const available = await Domain.isAvailable(this.domainname.toLowerCase())
          .catch((el) => {
            console.log('searchresult catch:::',el)
            //this.domains.all().splice(index - 1, 1)
          })
        console.log('AVAIL::::',available)
        //const p = this.formatPrice(available.data.available ? this.price.find(available.data.tld).create : this.price.find(available.data.tld).transfer)
        const ppp = this.price.find(available.data.tld) ? this.price.find(available.data.tld).create : false
        const pp = this.price.find(available.data.tld) ? this.price.find(available.data.tld).transfer : false
        const p = ppp ? ppp : pp
        const price = this.formatPrice( p )
        DomainSearchResult.insertOrUpdate({data: {
            name:this.domainname.toLowerCase(),
            available: available.data.available ?  available.data.available : 'false',
            selected: 'false',
            price: price,
            year:1,
            sld:available.data.sld ? available.data.sld : 'notset',
            tld:available.data.tld ? available.data.tld : 'notset'
          }})
        /*  if (available.data.available === undefined)
            this.domains.splice(index - 1, 1)
          else if (!domain.available)
            domain.selected = false
         */

        //this.domains = JSON.parse(localStorage.getItem('domains'))
        const w = this.domainname = ''
      },
      checkDomainNameDuplicate(){
        if(!this.domainC)return false
        const duplicates = this.domainC.map(
          (el,index)=> el.name
        )

        duplicates.includes(this.domainname) ? this.duplicate = true : this.duplicate = false
        return duplicates.includes(this.domainname)
      }
    }
  }
</script>

<style scoped>
  .verticalcenter{
    margin-top: auto;
    margin-bottom: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/domain/create_domain/luma-search-domain.vue